import "./homewidgetsm.css"
import { Visibility } from "@material-ui/icons"

export default function Homewidgetsm() {
  return (
    <div className="homewidgetsm">
      <span className="homewidgetsmTitle"> New Members</span>
      <ul className="homewidgetsmList">
        <li className="homewidgetsmListItem">
          <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387" alt="" className="img homewidgetsmImg"></img>
          <div className="homepagewidgetSmUser">
               <span className="homepagewidgetsmUserName">John Baxt</span>
               <span className="homepagewidgetsmUserTitle">Engineer</span>
          </div>
          <button className="homewidgetsmButton">
            <Visibility className="homewidgetsmIcon" />
            Display
          </button>
        </li>

        <li className="homewidgetsmListItem">
          <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387" alt="" className="img homewidgetsmImg"></img>
          <div className="homepagewidgetSmUser">
               <span className="homepagewidgetsmUserName">John Baxt</span>
               <span className="homepagewidgetsmUserTitle">Engineer</span>
          </div>
          <button className="homewidgetsmButton">
            <Visibility className="homewidgetsmIcon" />
            Display
          </button>
        </li>

        <li className="homewidgetsmListItem">
          <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387" alt="" className="img homewidgetsmImg"></img>
          <div className="homepagewidgetSmUser">
               <span className="homepagewidgetsmUserName">John Baxt</span>
               <span className="homepagewidgetsmUserTitle">Engineer</span>
          </div>
          <button className="homewidgetsmButton">
            <Visibility className="homewidgetsmIcon" />
            Display
          </button>
        </li>

        <li className="homewidgetsmListItem">
          <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387" alt="" className="img homewidgetsmImg"></img>
          <div className="homepagewidgetSmUser">
               <span className="homepagewidgetsmUserName">John Baxt</span>
               <span className="homepagewidgetsmUserTitle">Engineer</span>
          </div>
          <button className="homewidgetsmButton">
            <Visibility className="homewidgetsmIcon" />
            Display
          </button>
        </li>

        <li className="homewidgetsmListItem">
          <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387" alt="" className="img homewidgetsmImg"></img>
          <div className="homepagewidgetSmUser">
               <span className="homepagewidgetsmUserName">John Baxt</span>
               <span className="homepagewidgetsmUserTitle">Engineer</span>
          </div>
          <button className="homewidgetsmButton">
            <Visibility className="homewidgetsmIcon" />
            Display
          </button>
        </li>
      </ul>
    </div>
  )
}
